const LOGIN_TRACKING_EVENTS = {
  login_page_email_interacted: 'login_page_email_interacted',
  login_page_password_interacted: 'login_page_password_interacted',
  login_page_forget_password_clicked: 'login_page_forget_password_clicked',
  login_page_forget_password_email_interacted:
    'login_page_forget_password_email_interacted',
  login_page_send_password_reset_link_click:
    'login_page_send_password_reset_link_click',
  login_page_send_password_reset_link_successful:
    'login_page_send_password_reset_link_successful',
  login_page_send_password_reset_link_failed:
    'login_page_send_password_reset_link_failed',
  login_page_login_click: 'login_page_login_click',
  login_page_post_login_otp_pop_up_appears:
    'login_page_post_login_otp_pop_up_appears',
  login_page_post_login_otp_pop_up_otp_interacted:
    'login_page_post_login_otp_pop_up_otp_interacted',
  login_page_post_login_otp_pop_up_login_and_confirm_clicked:
    'login_page_post_login_otp_pop_up_login_and_confirm_clicked',
  login_successful: 'login_successful',
  login_failed: 'login_failed',
  login_page_sign_in_with_google_clicked:
    'login_page_sign_in_with_google_clicked',
}

export const ADS_TRACKING_EVENTS = {
  ads_page_view: 'ads_page_view',
  ads_campaign_create_start: 'ads_campaign_create_start',
  ads_campaign_create_progress: 'ads_campaign_create_progress',
  ads_campaign_create_complete: 'ads_campaign_create_complete',
  ads_campaign_edit_start: 'ads_campaign_edit_start',
  ads_campaign_edit_complete: 'ads_campaign_edit_complete',
  ads_topup_start: 'ads_topup_start',
  ads_topup_progress: 'ads_topup_progress',
  ads_topup_complete: 'ads_topup_complete',
}

export const DEALS_TRACKING_EVENTS = {
  deals_campaign_create_start: 'deals_campaign_create_start',
  deals_campaign_create_progress: 'deals_campaign_create_progress',
  deals_campaign_create_complete: 'deals_campaign_create_complete',
  deals_campaign_edit_start: 'deals_campaign_edit_start',
  deals_campaign_edit_complete: 'deals_campaign_edit_complete',
  deals_advertiser_created: 'deals_advertiser_created',
}

const NAVIGATION_BAR_EVENTS = {
  global_navbar_dashboard_clicked: 'global_navbar_dashboard_clicked',
  global_navbar_orders_clicked: 'global_navbar_orders_clicked',
  global_navbar_disputes_clicked: 'global_navbar_disputes_clicked',
  global_navbar_settlement_clicked: 'global_navbar_settlement_clicked',
  global_navbar_invoices_clicked: 'global_navbar_invoices_clicked',
  global_navbar_transactions_clicked: 'global_navbar_transactions_clicked',
  global_navbar_billing_clicked: 'global_navbar_billing_clicked',
  global_navbar_business_address_clicked:
    'global_navbar_business_address_clicked',
  global_navbar_exported_requests_clicked:
    'global_navbar_exported_requests_clicked',
  global_navbar_contact_information_clicked:
    'global_navbar_contact_information_clicked',
  global_navbar_webhooks_clicked: 'global_navbar_webhooks_clicked',
  global_navbar_instore_settings_clicked:
    'global_navbar_instore_settings_clicked',
  global_navbar_instore_barcode_clicked:
    'global_navbar_instore_barcode_clicked',
  global_navbar_manage_branches_clicked:
    'global_navbar_manage_branches_clicked',
  global_navbar_instore_material_clicked:
    'global_navbar_instore_material_clicked',
  global_navbar_api_tokens_clicked: 'global_navbar_api_tokens_clicked',
  global_navbar_users_clicked: 'global_navbar_users_clicked',
  global_navbar_manage_users_clicked: 'global_navbar_manage_users_clicked',
  global_navbar_manage_roles_clicked: 'global_navbar_manage_roles_clicked',
  global_navbar_documenation_clicked: 'global_navbar_documenation_clicked',
  global_navbar_partner_marketing_kit_clicked:
    'global_navbar_partner_marketing_kit_clicked',
  global_navbar_minimize_clicked: 'global_navbar_minimize_clicked',
  global_navbar_maximize_clicked: 'global_navbar_maximize_clicked',
  global_navbar_accounts_header_clicked:
    'global_navbar_accounts_header_clicked',
  global_navbar_id_copy: 'global_navbar_id_copy',
  global_navbar_accounts_search_interacted:
    'global_navbar_accounts_search_interacted',
  global_navbar_accounts_list_clicked: 'global_navbar_accounts_list_clicked',
  global_navbar_accounts_search_results_found_viewed:
    'global_navbar_accounts_search_results_found_viewed',
  global_navbar_accounts_search_no_results_found_viewed:
    'global_navbar_accounts_search_no_results_found_viewed',
  global_navbar_deals_billing_clicked: 'global_navbar_deals_billing_clicked',
}

const PAGE_VIEW_EVENTS = {
  login_page_viewed: 'login_page_viewed',
  dashboard_viewed: 'dashboard_viewed',
  order_list_viewed: 'orders_listing_viewed',
  dispute_list_viewed: 'disputes_listing_viewed',
  settlement_list_viewed: 'settlements_viewed',
  invoice_list_viewed: 'invoices_viewed',
  transaction_list_viewed: 'transactions_viewed',
  instore_material_page_viewed: 'instore_material_page_viewed',
  deals_page_view: 'deals_page_view',
}

export const SETTLEMENT_TRACKING_EVENTS = {
  settlement_overview_of_settlement_tooltip_hover:
    'settlement_overview_of_settlement_tooltip_hover',
  settlement_account_dropdown_clicked: 'settlement_account_dropdown_clicked',
  settlement_country_dropdown_clicked: 'settlement_country_dropdown_clicked',
  settlements_how_it_works_clicked: 'settlements_how_it_works_clicked',
  settlements_how_it_works_tab_video_played_clicked:
    'settlements_how_it_works_tab_video_played_clicked',
  settlement_not_paid_yet_tooltip_hover:
    'settlement_not_paid_yet_tooltip_hover',
  settlement_current_balance_up_to_now_tooltip_hover:
    'settlement_current_balance_up_to_now_tooltip_hover',
  settlement_last_settled_amount_tooltip_hover:
    'settlement_last_settled_amount_tooltip_hover',
  settlement_settlement_details_tooltip_hover:
    'settlement_settlement_details_tooltip_hover',
  settlements_filter: 'settlements_filter',
  settlements_clear_all_clicked: 'settlements_clear_all_clicked',
  settlements_export_all_clicked: 'settlements_export_all_clicked',
  settlements_status_clicked: 'settlements_status_clicked',
  settlement_table_export_button_clicked_failed:
    'settlement_table_export_button_clicked_failed',
  settlement_table_export_button_clicked_successful:
    'settlement_table_export_button_clicked_successful',
  settlement_table_export_button_tooltip_hovered:
    'settlement_table_export_button_tooltip_hovered',
  settlement_row_clicked: 'settlement_row_clicked',
  settlement_settlement_export_clicked: 'settlement_settlement_export_clicked',
}

const VIDEO_GUIDE_TRACKING_EVENTS = {
  video_guide_drawer_open: 'video_guide_drawer_open',
}

const INVOICE_TRACKING_EVENTS = {
  invoices_filter: 'invoices_filter',
  invoices_clear_all_clicked: 'invoices_clear_all_clicked',
  invoices_export_invoices_clicked_failed:
    'invoices_export_invoices_clicked_failed',
  invoices_export_invoices_clicked_successful:
    'invoices_export_invoices_clicked_successful',
  invoices_export_invoices_tooltip_hovered:
    'invoices_export_invoices_tooltip_hovered',
  invoices_invoice_clicked: 'invoices_invoice_clicked',
  invoices_invoice_export_clicked: 'invoices_invoice_export_clicked',
}

const TRANSACTION_TRACKING_EVENTS = {
  transaction_search_clicked: 'transaction_search_clicked',
  transactions_export_all_clicked: 'transaction_export_all_clicked',
  transactions_export_all_clicked_failed:
    'transactions_export_all_clicked_failed',
  transactions_export_all_clicked_successful:
    'transactions_export_all_clicked_successful',
  transactions_export_all_tooltip_hovered:
    'transactions_export_all_tooltip_hovered',
  transactions_filter: 'transactions_filter',
  transactions_clear_all_clicked: 'transactions_clear_all_clicked',
  transactions_order_reference_id_copy_clicked:
    'transactions_order_reference_id_copy_clicked',
  transactions_tamara_id_copy_clicked: 'transactions_tamara_id_copy_clicked',
  transactions_order_number_copy_clicked:
    'transactions_order_number_copy_clicked',
  transactions_tamara_txn_id_copy_clicked:
    'transactions_tamara_txn_id_copy_clicked',
  transactions_transaction_clicked: 'transactions_transaction_clicked',
}

const ORDER_TRACKING_EVENTS = {
  orders_filter: 'orders_filter',
  orders_clear_all_clicked: 'orders_clear_all_clicked',
  orders_search: 'orders_search',
  orders_status_clicked: 'orders_status_clicked',
  orders_export_all_clicked_failed: 'orders_export_all_clicked_failed',
  orders_export_all_clicked_successful: 'orders_export_all_clicked_successful',
  orders_export_all_hovered: 'orders_export_all_hovered',
  orders_listing_pagination: 'orders_listing_pagination',
  orders_order_clicked: 'orders_order_clicked',
  orders_how_it_works_clicked: 'orders_how_it_works_clicked',
  orders_how_it_works_tab_video_played_clicked:
    'orders_how_it_works_tab_video_played_clicked',
  orders_how_it_works_tab_video_2_played_clicked:
    'orders_how_it_works_tab_video_2_played_clicked',
  orders_how_it_works_tab_2_expand_clicked:
    'orders_how_it_works_tab_2_expand_clicked',
  orders_listing_order_id_copy_clicked: 'orders_listing_order_id_copy_clicked',
  orders_order_details_how_it_works_clicked:
    'orders_order_details_how_it_works_clicked',
  orders_order_details_how_it_works_tab_video_1_played_clicked:
    'orders_order_details_how_it_works_tab_video_1_played_clicked',
  orders_order_details_how_it_works_tab_video_2_played_clicked:
    'orders_order_details_how_it_works_tab_video_2_played_clicked',
  orders_order_details_how_it_works_tab_tab2_expanded:
    'orders_order_details_how_it_works_tab_tab2_expanded',
  orders_order_details_second_id_copy_clicked:
    'orders_order_details_second_id_copy_clicked',
  orders_order_details_first_id_copy_clicked:
    'orders_order_details_first_id_copy_clicked',
  orders_order_details_first_id_dropdown_clicked:
    'orders_order_details_first_id_dropdown_clicked',
  orders_order_details_first_id_edit_clicked:
    'orders_order_details_first_id_edit_clicked',
  orders_order_details_first_id_edit_save_clicked:
    'orders_order_details_first_id_edit_save_clicked',
  orders_order_details_items_search: 'orders_order_details_items_search',
  orders_order_details_action_clicked: 'orders_order_details_action_clicked',
  orders_order_details_items_click: 'orders_order_details_items_click',
  orders_order_activity_log_filter: 'orders_order_activity_log_filter',
  orders_listing_order_number_copy_clicked:
    'orders_listing_order_number_copy_clicked',
}

const DISPUTE_TRACKING_EVENTS = {
  disputes_filter: 'disputes_filter',
  disputes_clear_all_clicked: 'disputes_clear_all_clicked',
  disputes_search: 'disputes_search',
  disputes_status_clicked: 'disputes_status_clicked',
  disputes_export_all_clicked_failed: 'disputes_export_all_clicked_failed',
  disputes_export_all_clicked_successful:
    'disputes_export_all_clicked_successful',
  disputes_export_all_hovered: 'disputes_export_all_hovered',
  disputes_listing_pagination: 'disputes_listing_pagination',
  disputes_dispute_clicked: 'disputes_dispute_clicked',
  disputes_dispute_view_case_clicked: 'disputes_dispute_view_case_clicked',
  disputes_awaiting_your_response_tooltip_hover:
    'disputes_awaiting_your_response_tooltip_hover',
  disputes_closed_disputes_tooltip_hover:
    'disputes_closed_disputes_tooltip_hover',
  disputes_under_tamra_review_tooltip_hover:
    'disputes_under_tamra_review_tooltip_hover',
  disputes_dispute_details_tamara_id_copy_clicked:
    'disputes_dispute_details_tamara_id_copy_clicked',
  disputes_dispute_details_order_id_copy_clicked:
    'disputes_dispute_details_order_id_copy_clicked',
  disputes_dispute_details_action_clicked:
    'disputes_dispute_details_action_clicked',
}

const DASHBOARD_TRACKING_EVENTS = {
  bank_view_banner_capital: 'bank_view_banner_capital',
  bank_tap_banner_capital: 'bank_tap_banner_capital',
  dashboard_banner_click: 'dashboard_banner_click',
  dashboard_filter: 'dashboard_filter',
  dashboard_gmv_tooltip_hover: 'dashboard_gmv_tooltip_hover',
  dashboard_aov_tooltip_hover: 'dashboard_aov_tooltip_hover',
  dashboard_order_count_tooltip_hover: 'dashboard_order_count_tooltip_hover',
  dashboard_graph_arrows_clicked: 'dashboard_graph_arrows_clicked',
  dashboard_overall_insights_gmv_tooltip_hovered:
    'dashboard_overall_insights_gmv_tooltip_hovered',
  dashboard_overall_insights_refunded_amount_tooltip_hovered:
    'dashboard_overall_insights_refunded_amount_tooltip_hovered',
  dashboard_overall_insights_refunded_order_value_tooltip_hovered:
    'dashboard_overall_insights_refunded_order_value_tooltip_hovered',
  dashboard_right_section_refresh_clicked:
    'dashboard_right_section_refresh_clicked',
  dashboard_right_section_settlement_currency_filter_clicked:
    'dashboard_right_section_settlement_currency_filter_clicked',
  dashboard_right_section_settlement_more_details_clicked:
    'dashboard_right_section_settlement_more_details_clicked',
  dashboard_right_section_orders_more_details_clicked:
    'dashboard_right_section_orders_more_details_clicked',
  dashboard_right_section_disputes_more_details_clicked:
    'dashboard_right_section_disputes_more_details_clicked',
  dashboard_right_section_disputes_arrow_clicked:
    'dashboard_right_section_disputes_arrow_clicked',
  dashboard_right_section_orders_arrow_clicked:
    'dashboard_right_section_orders_arrow_clicked',
  dashboard_right_section_orders_order_clicked:
    'dashboard_right_section_orders_order_clicked',
  dashboard_right_section_orders_dispute_clicked:
    'dashboard_right_section_orders_dispute_clicked',
  dashboard_cashier_view_order_creation_preference_changed:
    'cashier_view__order_creation_preference_changed',
}

const GLOBAL_HEADER_TRACKING_EVENTS = {
  global_header_tooltip_hover: 'global_header_tooltip_hover',
  global_language_change_to_arabic: 'global_language_change_to_arabic',
  global_language_change_to_english: 'global_language_change_to_english',
  global_notifications_click: 'global_notifications_click',
  global_notifications_list_view_all: 'global_notifications_list_view_all',
  global_notifications_list_item_click: 'global_notifications_list_item_click',
  global_chat_with_us: 'global_chat_with_us',
  global_create_order: 'global_create_order',
  global_profile_icon: 'global_profile_icon',
  global_profile_dropdown_user_settings:
    'global_profile_dropdown_user_settings',
  global_profile_dropdown_support: 'global_profile_dropdown_support',
  global_profile_dropdown_help: 'global_profile_dropdown_help',
  global_profile_dropdown_logout: 'global_profile_dropdown_logout',
  global_profile_dropdown_logout_error: 'global_profile_dropdown_logout_error',
  global_header__switch_to_cashier_view:
    'global_header__switch_to_cashier_view',
}

const USER_SETTINGS_TRACKING_EVENTS = {
  user_settings_field_clicked: 'user_settings_field_clicked',
}

const EVENT_TRACKING_MAP = {
  page_view: PAGE_VIEW_EVENTS,
  ...LOGIN_TRACKING_EVENTS,
  ...DEALS_TRACKING_EVENTS,
  ...NAVIGATION_BAR_EVENTS,
  ...SETTLEMENT_TRACKING_EVENTS,
  ...VIDEO_GUIDE_TRACKING_EVENTS,
  ...INVOICE_TRACKING_EVENTS,
  ...TRANSACTION_TRACKING_EVENTS,
  ...ORDER_TRACKING_EVENTS,
  ...DISPUTE_TRACKING_EVENTS,
  ...DASHBOARD_TRACKING_EVENTS,
  ...GLOBAL_HEADER_TRACKING_EVENTS,
  ...USER_SETTINGS_TRACKING_EVENTS,
}

export default EVENT_TRACKING_MAP
